import { render, staticRenderFns } from "./pnl.vue?vue&type=template&id=63fa0c5f&scoped=true"
import script from "./pnl.vue?vue&type=script&lang=js"
export * from "./pnl.vue?vue&type=script&lang=js"
import style0 from "./pnl.vue?vue&type=style&index=0&id=63fa0c5f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63fa0c5f",
  null
  
)

export default component.exports